import { render } from "./relatedPostSection.vue?vue&type=template&id=17c28fd0&scoped=true"
import script from "./relatedPostSection.vue?vue&type=script&lang=js"
export * from "./relatedPostSection.vue?vue&type=script&lang=js"

import "./relatedPostSection.vue?vue&type=style&index=0&id=17c28fd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c28fd0"]])

export default __exports__